import React from 'react';
import { cn } from '../poker-ui/utils/cn';

/**
 * Подтверждение выхода из локальной Секи: итог по фишкам и возврат остатка в кошелёк.
 */
export function LocalSekaLeaveModal({
  open,
  onClose,
  onConfirm,
  heroChips,
  sessionStartStack,
  midHand,
}) {
  if (!open) return null;

  const start = Math.max(0, Math.floor(Number(sessionStartStack) || 0));
  const chips = Math.max(0, Math.floor(Number(heroChips) || 0));
  const rawDelta = chips - start;
  const deltaLabel = `${rawDelta > 0 ? '+' : ''}${rawDelta.toLocaleString('ru-RU')}`;
  const deltaTone =
    rawDelta > 0 ? 'text-emerald-400' : rawDelta < 0 ? 'text-red-400' : 'text-zinc-200';

  return (
    <div
      className="fixed inset-0 z-[72] overflow-y-auto overscroll-contain bg-black/70"
      role="dialog"
      aria-modal="true"
      aria-labelledby="leave-seka-title"
      onClick={onClose}
    >
      <div
        className="relative flex min-h-[100dvh] w-full items-center justify-center p-3 py-3 sm:p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={cn(
            'w-full max-w-[min(92vw,340px)] rounded-2xl border-2 border-amber-500/55',
            'bg-[#12100e] px-4 py-4 shadow-[0_12px_40px_rgba(0,0,0,0.65)] sm:px-5 sm:py-5'
          )}
        >
          <h2
            id="leave-seka-title"
            className="text-center text-base font-black uppercase tracking-wide text-amber-200 sm:text-lg"
          >
            Покинуть стол?
          </h2>
          <p className="mt-3 text-center text-sm font-medium leading-snug text-zinc-100">
            На столе{' '}
            <span className="font-mono font-bold text-amber-200">
              {chips.toLocaleString('ru-RU')} SEKA
            </span>
            {start > 0 ? (
              <>
                {' · '}к старту{' '}
                <span className={cn('font-mono font-bold', deltaTone)}>{deltaLabel} SEKA</span>
              </>
            ) : null}
          </p>
          {midHand ? (
            <p className="mt-2.5 text-center text-xs leading-snug text-zinc-300">
              В раздаче — засчитаем пас, доиграем ботов.
            </p>
          ) : null}
          <div className="mt-4 grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-11 items-center justify-center rounded-lg border border-zinc-500/80 bg-zinc-800 text-xs font-bold text-zinc-100 transition hover:bg-zinc-700"
            >
              Продолжить
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex h-11 items-center justify-center rounded-lg border border-emerald-500/80 bg-emerald-700 text-xs font-black text-white transition hover:bg-emerald-600"
            >
              В карман и выйти
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
